// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/twinkle-arpeggios.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const twinkleArpeggios: Score = {
  slug: "twinkle-arpeggios",
  n: 11,
  title: "Twinkle Twinkle \u2014 Arpeggios",
  composer: "Mozart",
  rights: "public-domain",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 96,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 13,
  barQuarters: 4.0,
  lowest: 47,
  highest: 69,
  hasLyrics: true,
  jasonNote: "Try out this Arpeggio pattern in the Left Hand to accompany the melody while adding rhythmic character. Experiment at different speeds",
  teaches: ["broken-chord left-hand pattern", "independence of hands", "experimenting with tempo"],
  art: "/sight-reading/art/twinkle-arpeggios.jpg",
  artRights: "stock",
  background: "/sight-reading/bg/twinkle-arpeggios.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", lyric: "Twin" },
    { bar: 1, hand: "lh", start: 0.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 1, hand: "lh", start: 0.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", lyric: "kle" },
    { bar: 1, hand: "lh", start: 1.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 1, hand: "lh", start: 1.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "Twin" },
    { bar: 1, hand: "lh", start: 2.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 1, hand: "lh", start: 2.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "kle" },
    { bar: 1, hand: "lh", start: 3.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 1, hand: "lh", start: 3.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 2, hand: "rh", start: 4.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter", lyric: "Li" },
    { bar: 2, hand: "lh", start: 4.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 2, hand: "lh", start: 4.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 2, hand: "rh", start: 5.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter", lyric: "ttle" },
    { bar: 2, hand: "lh", start: 5.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 2, hand: "lh", start: 5.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 67, pitch: "G4", d: "half", lyric: "star" },
    { bar: 2, hand: "lh", start: 6.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 2, hand: "lh", start: 6.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 2, hand: "lh", start: 7.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 2, hand: "lh", start: 7.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "How" },
    { bar: 3, hand: "lh", start: 8.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 3, hand: "lh", start: 8.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 3, hand: "rh", start: 9.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "I" },
    { bar: 3, hand: "lh", start: 9.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 3, hand: "lh", start: 9.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "won" },
    { bar: 3, hand: "lh", start: 10.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 3, hand: "lh", start: 10.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "der" },
    { bar: 3, hand: "lh", start: 11.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 3, hand: "lh", start: 11.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 4,
  hand: "rh",
  start: 12.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "what"
},
    { bar: 4, hand: "lh", start: 12.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 4, hand: "lh", start: 12.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 4, hand: "rh", start: 13.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", lyric: "you" },
    { bar: 4, hand: "lh", start: 13.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 4, hand: "lh", start: 13.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 4, hand: "rh", start: 14.0, dur: 2.0, midi: 60, pitch: "C4", d: "half", lyric: "are" },
    { bar: 4, hand: "lh", start: 14.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 4, hand: "lh", start: 14.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 4, hand: "lh", start: 15.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 4, hand: "lh", start: 15.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "up" },
    { bar: 5, hand: "lh", start: 16.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 5, hand: "lh", start: 16.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 5, hand: "rh", start: 17.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "A" },
    { bar: 5, hand: "lh", start: 17.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 5, hand: "lh", start: 17.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 5,
  hand: "rh",
  start: 18.0,
  dur: 1.0,
  midi: 65,
  pitch: "F4",
  d: "quarter",
  lyric: "bove"
},
    { bar: 5, hand: "lh", start: 18.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 5, hand: "lh", start: 18.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "the" },
    { bar: 5, hand: "lh", start: 19.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 5, hand: "lh", start: 19.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    {
  bar: 6,
  hand: "rh",
  start: 20.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "world"
},
    { bar: 6, hand: "lh", start: 20.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 6, hand: "lh", start: 20.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 6, hand: "rh", start: 21.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "so" },
    { bar: 6, hand: "lh", start: 21.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 6, hand: "lh", start: 21.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 62, pitch: "D4", d: "half", lyric: "high" },
    { bar: 6, hand: "lh", start: 22.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 6, hand: "lh", start: 22.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 6, hand: "lh", start: 23.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 6, hand: "lh", start: 23.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 7,
  hand: "rh",
  start: 24.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "like"
},
    { bar: 7, hand: "lh", start: 24.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 7, hand: "lh", start: 24.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 7, hand: "rh", start: 25.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "a" },
    { bar: 7, hand: "lh", start: 25.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 7, hand: "lh", start: 25.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "dia" },
    { bar: 7, hand: "lh", start: 26.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 7, hand: "lh", start: 26.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    {
  bar: 7,
  hand: "rh",
  start: 27.0,
  dur: 1.0,
  midi: 65,
  pitch: "F4",
  d: "quarter",
  lyric: "mond"
},
    { bar: 7, hand: "lh", start: 27.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 7, hand: "lh", start: 27.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 8, hand: "rh", start: 28.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "in" },
    { bar: 8, hand: "lh", start: 28.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 8, hand: "lh", start: 28.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 8, hand: "rh", start: 29.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "the" },
    { bar: 8, hand: "lh", start: 29.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 8, hand: "lh", start: 29.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 8, hand: "rh", start: 30.0, dur: 2.0, midi: 62, pitch: "D4", d: "half", lyric: "sky" },
    { bar: 8, hand: "lh", start: 30.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 8, hand: "lh", start: 30.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 8, hand: "lh", start: 31.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 8, hand: "lh", start: 31.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 9,
  hand: "rh",
  start: 32.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  lyric: "Twin"
},
    { bar: 9, hand: "lh", start: 32.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 9, hand: "lh", start: 32.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 9, hand: "rh", start: 33.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", lyric: "kle" },
    { bar: 9, hand: "lh", start: 33.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 9, hand: "lh", start: 33.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 9,
  hand: "rh",
  start: 34.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "Twin"
},
    { bar: 9, hand: "lh", start: 34.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 9, hand: "lh", start: 34.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 9, hand: "rh", start: 35.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "kle" },
    { bar: 9, hand: "lh", start: 35.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 9, hand: "lh", start: 35.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 10, hand: "rh", start: 36.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter", lyric: "Li" },
    { bar: 10, hand: "lh", start: 36.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 10, hand: "lh", start: 36.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    {
  bar: 10,
  hand: "rh",
  start: 37.0,
  dur: 1.0,
  midi: 69,
  pitch: "A4",
  d: "quarter",
  lyric: "ttle"
},
    { bar: 10, hand: "lh", start: 37.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 10, hand: "lh", start: 37.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 10, hand: "rh", start: 38.0, dur: 2.0, midi: 67, pitch: "G4", d: "half", lyric: "star" },
    { bar: 10, hand: "lh", start: 38.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 10, hand: "lh", start: 38.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 10, hand: "lh", start: 39.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 10, hand: "lh", start: 39.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 11,
  hand: "rh",
  start: 40.0,
  dur: 1.0,
  midi: 65,
  pitch: "F4",
  d: "quarter",
  lyric: "How"
},
    { bar: 11, hand: "lh", start: 40.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 11, hand: "lh", start: 40.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 11, hand: "rh", start: 41.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "i" },
    { bar: 11, hand: "lh", start: 41.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 11, hand: "lh", start: 41.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 11,
  hand: "rh",
  start: 42.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "won"
},
    { bar: 11, hand: "lh", start: 42.0, dur: 0.5, midi: 48, pitch: "C3", d: "eighth" },
    { bar: 11, hand: "lh", start: 42.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 11,
  hand: "rh",
  start: 43.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "der"
},
    { bar: 11, hand: "lh", start: 43.0, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 11, hand: "lh", start: 43.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 12,
  hand: "rh",
  start: 44.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "what"
},
    { bar: 12, hand: "lh", start: 44.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 12, hand: "lh", start: 44.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 12,
  hand: "rh",
  start: 45.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "you"
},
    { bar: 12, hand: "lh", start: 45.0, dur: 0.5, midi: 53, pitch: "F3", d: "eighth" },
    { bar: 12, hand: "lh", start: 45.5, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    {
  bar: 12,
  hand: "rh",
  start: 46.0,
  dur: 2.0,
  midi: 60,
  pitch: "C4",
  d: "half",
  tie: "start",
  lyric: "are"
},
    { bar: 12, hand: "lh", start: 46.0, dur: 2.0, midi: 48, pitch: "C3", d: "half", tie: "start" },
    { bar: 12, hand: "lh", start: 46.0, dur: 2.0, midi: 52, pitch: "E3", d: "half", chord: true },
    { bar: 13, hand: "rh", start: 48.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole", tie: "stop" },
    { bar: 13, hand: "lh", start: 48.0, dur: 4.0, midi: 48, pitch: "C3", d: "whole", tie: "stop" },
    { bar: 13, hand: "lh", start: 48.0, dur: 4.0, midi: 52, pitch: "E3", d: "whole", chord: true },
  ],
};
